import { AnalyticsModules } from '../Analytics.types';
import { EventParams } from '../Event.types';
import { InstancesStore } from '../context';

export const sendEvent = (
  eventName: string,
  devEnvironment: boolean,
  instanceName: string,
  instance: AnalyticsModules,
  eventParams?: EventParams
) => {
  if (!instance?.logEvent)
    return console.error(`[${instanceName}] is not available`);
  if (devEnvironment) {
    console.log(` [${instanceName}] AnalyticsEvent: ` + eventName);
  }
  instance.logEvent(eventName, eventParams);
};

export const handleEventSending = (
  instances: InstancesStore,
  devEnvironment: boolean,
  eventName: string,
  eventParams?: EventParams
): void => {
  const specifiedInstanceName = eventParams?.options?.sendTo;

  if (specifiedInstanceName) {
    if (Array.isArray(specifiedInstanceName)) {
      specifiedInstanceName.forEach(instanceName => {
        const currentInstance = instances[instanceName]?.instance;

        sendEvent(
          eventName,
          devEnvironment,
          instanceName,
          currentInstance,
          eventParams
        );
      });
      return;
    }

    const currentSpecifiedInstance = instances[specifiedInstanceName]?.instance;

    return sendEvent(
      eventName,
      devEnvironment,
      specifiedInstanceName as string,
      currentSpecifiedInstance,
      eventParams
    );
  }

  for (let instanceName in instances) {
    const currentInstance = instances[instanceName]?.instance;

    sendEvent(
      eventName,
      devEnvironment,
      instanceName,
      currentInstance,
      eventParams
    );
  }
};
